export default __webpack_public_path__ + "static/media/sharpgrotesk-medium20-webfont.69ced77e.woff";